import MenuOptions from "../../components/order/menu/MenuOptions";

export default function PointLeaderboardMenu({ order, mobile, onView }) {
  const menu = [
    {
      label: "View more",
      action: () => {
        onView?.();
      },
      visible: true,
    },
    // {
    //   label: "Delete reward",
    //   action: () => {
    //     onDelete?.();
    //   },
    //   visible: true,
    // },
  ];

  return (
    <>
      <div className="hidden"></div>
      <MenuOptions mobile={mobile} menu={menu} />
    </>
  );
}
// Stay menu
